<template>
  <svg viewBox="0 0 377 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.5 8.95082H86.9057L94.5529 2.61629C95.2949 1.88513 96.3014 1.47411 97.3511 1.47363H376.5"
      stroke="#FFAF00"
      stroke-miterlimit="10"
    />
    <path d="M87.1203 9H0V7H89L87.1203 9Z" fill="#FFAF00" />
  </svg>
</template>
